<template>
  <div>
    <a-row>
      <a-tabs defaultActiveKey="1">
        <a-tab-pane  v-if="!tieneRolSegSelfservice"  tab="ROL" key="1">
          <mantenimiento-role></mantenimiento-role>
        </a-tab-pane>
        <a-tab-pane tab="USUARIO" key="2">
          <g-master name="user"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    ref="master"
                    @action="masterAction"
          >
            <template slot="masterModal" slot-scope="{record}">
              <a-row :gutter="[16,16]">
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Nombre')">
                    <a-input
                      v-decorator="['name', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Contraseña')">
                    <a-input
                      v-decorator="['password', { rules: [{ required: required_password, message: 'Valor requerido'}] }]"/>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <g-lookup v-bind="fiOptions"
                            endpoint="personas"
                            :label="$t('ID persona')"
                            :formItemConfig="fiOptions"
                            :decorator="['id_person', { rules: [{ required: false}] }]"
                  >
                  </g-lookup>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item :label="$t('Estado')" v-bind="fiOptions">
                    <a-select
                      v-decorator="[
                    'status',
                    { rules: [{ required: false}], initialValue: 'I' },
                  ]"
                    >
                      <a-select-option value="A">
                        ACTIVO
                      </a-select-option>
                      <a-select-option value="I">
                        INACTIVO
                      </a-select-option>
                    </a-select>
                  </a-form-item>
                </a-col>
                <a-col v-bind="colOptions">
                  <a-form-item v-bind="fiOptions" :label="$t('Fecha límite')">
                    <a-date-picker style="width: 100%"
                                   v-decorator="['limit_date', { rules: [{ required: false}] }]"
                    ></a-date-picker>
                  </a-form-item>
                </a-col>
              </a-row>
            </template>
          </g-master>
          <a-tabs defaultActiveKey="2">
            <a-tab-pane tab="Compañía" v-if="!tieneRolSegSelfservice" key="2">
              <mantenimiento-user-company v-if="idForm" :name="idForm"></mantenimiento-user-company>
              <span v-else>Seleccione un usuario para ver más.</span>
            </a-tab-pane>
            <a-tab-pane v-if="!tieneRolSegSelfservice"  tab="Rol de usuario" key="1">
              <mantenimiento-user-role v-if="idForm" :name="idForm"></mantenimiento-user-role>
              <span v-else>Seleccione un usuario para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="Localidades" v-if="!tieneRolSegSelfservice" key="3">
              <mantenimiento-location-user v-if="idForm" :name="idForm"></mantenimiento-location-user>
              <span v-else>Seleccione un usuario para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="Persona" v-if="!tieneRolSegSelfservice" key="4">
              <mantenimiento-person-user v-if="idForm" :name="idForm"></mantenimiento-person-user>
              <span v-else>Seleccione un usuario para ver más.</span>
            </a-tab-pane>
            <a-tab-pane tab="Grupo" v-if="!tieneRolSegSelfservice" key="5">
              <mantenimiento-user-groups v-if="idForm" :name="idForm"></mantenimiento-user-groups>
              <span v-else>Seleccione un usuario para ver más.</span>
            </a-tab-pane>
          </a-tabs>
        </a-tab-pane>
        <a-tab-pane v-if="!tieneRolSegSelfservice" tab="NODO NIVEL 1" key="3">
          <mantenimiento-node></mantenimiento-node>
        </a-tab-pane>
        <a-tab-pane v-if="!tieneRolSegSelfservice" tab="ACCIÓN" key="4">
          <mantenimiento-action></mantenimiento-action>
        </a-tab-pane>
      </a-tabs>
    </a-row>
    <a-row>
    </a-row>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    data () {
      return {
        required_password: true,
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'mantenimiento_user',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID Persona', dataIndex: 'id_person', sorter: true},
              {title: 'Nombre de usuario', dataIndex: 'name', sorter: true},
              {title: 'Nombre', dataIndex: 'nombre_completo', sorter: true},
              {title: 'Estado', dataIndex: 'status_desc', sorter: true},
              {title: 'Fecha límite', dataIndex: 'limit_date_desc', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'name'},
            {name: 'id_person'},
            {name: 'status'},
            {name: 'limit_date', type: 'date'},
            {name: 'password'}
          ]
        }
      }
    },
    computed: {
      idForm () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].name : null
      },
      tieneRolSegSelfservice () {
        return this.$userIsInrol('SegSelfService')
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        this.required_password = action.action === 'masterCreate'
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/User/MantenimientoSeguridad.vue